import { createContext, Fragment, useContext, useState } from 'react'

import SlidingPane from 'react-sliding-pane'

import AssociateToFolders from './AssociateToFolders'

interface AssociationContextValue {
  openAssociation: (collectionId: string) => void
  closeAssociation: () => void
}

const Context = createContext<AssociationContextValue | undefined>(undefined)
Context.displayName = 'AssociationContext'

export const useAssociation = () => {
  const ctx = useContext(Context)
  if (!ctx) {
    throw new Error(
      'useAssociation must be used inside AssociationContext provider'
    )
  }
  return ctx
}

interface Props {
  children: React.ReactNode | React.ReactNode[]
}

const AssociationContext = ({ children }: Props) => {
  const [collectionId, setCollectionId] = useState<string | undefined>(
    undefined
  )

  const openAssociation = (collectionId: string) => {
    setCollectionId(collectionId)
  }

  const closeAssociation = () => setCollectionId(undefined)

  const isOpen = !!collectionId

  return (
    <Fragment>
      <Context.Provider value={{ openAssociation, closeAssociation }}>
        {children}
      </Context.Provider>
      {isOpen && collectionId && (
        <SlidingPane
          from="bottom"
          hideHeader
          isOpen={isOpen}
          onRequestClose={closeAssociation}
          overlayClassName="z-30 w-screen"
          shouldCloseOnEsc
          width="100%"
        >
          <AssociateToFolders id={collectionId} />
        </SlidingPane>
      )}
    </Fragment>
  )
}

export default AssociationContext
